/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


var totalslides,slidewidth,currentslide,screenslides,finalslide,collection_slidewidth;
var collection_totalslides;
var memgenderlist,memcatlist,advancedmenu;
var logobartime,logobardirection=-1;
var advancedmenutopics=[];



$( document ).ready(function() {
  $(".js .features--show-page-transition .PageTransition").css({
visibility:"visible",
opacity: 0
  });
  
/* Footer menu sublevels */
  $("#section-footer .Link--primary[href='#']").on("click",function() {
    nextul=$(this).next("ul");
    if(nextul.is(":visible"))
      nextul.slideUp();
     else
      nextul.slideDown();
	return false;
  })

  /* Make main menu items clickable */  
  $(".MegaMenu__Inner a").each(function() {
	menulink=$(this).text();
    if(menulink=="Zeig mir alles!")
      $(this).parent().remove();
  })  

  /* Minimenu */
  if($("#minimenu").length && $("#minimenu span").position()) {
    selectedpos=$("#minimenu span").position().left;
    $(".minimenu--wrapper").scrollLeft(selectedpos);
  }
  $("#minimenu_form select").on("change",function() {
 	goto=$("#minimenu_form select option:selected").data("href");
    if(goto.indexOf("#")==0) {
      $("a[href='"+goto+"']").click();
    } else if(goto) location.href=goto;
    return false;
  })

/* Redesign Bewerben button */
  if($("a:contains('etzt online bewerben')").length) {
    $("a:contains('etzt online bewerben')").addClass("Button Button--secondary").css({"background-color":"#747364","color":"#ffffff"});
    stellenname=encodeURIComponent($("h1.SectionHeader__Heading:first").text());
    goto=$("a:contains('etzt online bewerben')").attr("href");
    $("a:contains('etzt online bewerben')").attr("href",goto+"?stelle="+stellenname)
  }
  stellenname=decodeURIComponent(getUrlParameter('stelle'));
  if(stellenname=="false") stellenname="";
  
  $("input[name='contact[stelle]']").val(stellenname);
  $("#bewerbung form#contact_form").on("submit", function(e) {
    e.preventDefault();
	if(1==1) {
		$.ajax({
		url: "https://newsletter.mode-funk.de/_bew/index.php",
		type: "POST",
		data:  new FormData(this),
		contentType: false,
		cache: false,
		processData:false,
		success: function(data){
          if(data=="Message sent!")
            $("#bewerbung .PageContent .Rte").html("<h1 class='center'>Vielen Dank!</h1><div class='center'>Deine Bewerbungsunterlagen wurden an uns übermittelt.<br />Wir melden uns in Kürze bei dir.</div>");
		},
		error: function(){} 	        	
		});
	}
    return false;
  })
  
/* Extend inspirations page */  
  pathname = window.location.pathname; 
  if(pathname=="/pages/frauen-inspiration" || pathname=="/pages/manner-inspiration") {
    var remote = $.ajax({
        type: "GET",
        url: pathname+"-2",
        async: false
    }).responseText;
  	var elements = $(remote);
	addmosaik = $('.InspirationMosaikWrapper', elements);
	addlist   = $('.InspirationListWrapper', elements);
    addtopic  = $('.inspiration-topic', elements);

    addsection= $('.InspirationSection', elements);
    
    $('.InspirationMosaikWrapper').last().after(addmosaik);
    $('.InspirationSection').last().after(addsection);    
  }
  
/* Mosaic navigation for inspirations */   
  mormosaic ='<div class="Container SpecialSize center trenner" id="stlmore"><header class="PageHeader"><div class="SectionHeader SectionHeader--center"><h1 class="SectionHeader__Heading Heading u-h1 center">Weitere Looks entdecken</h1></div></header>';
  if($(".InspirationMosaik--item").length) {
    mormosaic+='<section id="mormosaic" data-section-type="mcollection-list"><div id="collection-bar2"><ul class="mcollection-bar__list">';
    $(".InspirationSection").each(function() {
	  section=$(this).attr("id");
      featimg=$(this).find(".FeatureText__ImageWrapper noscript").html().trim();

      featimg=featimg.replace("data-src","src");
      featimg=featimg.replace("_800x1000_","_400x500_");
      featimg=featimg.replace(/^.* src=./ig,"");
      featimg=featimg.replace(/".*$/ig,"");
      featimg=featimg.replace(/'.*$/ig,"");      
      feattxt=$(this).find(".FeatureText__ContentWrapper").find("h2.SectionHeader__Heading.Heading.u-h1").text();
      mormosaic+='<li class="mcollection-bar__item"><a href="#" data-section='+section+'><img src="'+featimg+'" alt="" /><span>'+feattxt+'</span></a></li>';
    });
  	mormosaic+='</ul></div></section>'; //</div>'; 
    $(".InspirationSection:last").parent("div").after(mormosaic); 
          
    $("#mormosaic a,.InspirationMosaik--item").on("click", function(){
      activestl=$(this).data("section");
	  $(".inspiration-mosaic").hide();
      $(".InspirationSection").hide();
      $("#"+activestl).show();
      
      $("#mormosaic").hide();
      mix($("#mormosaic .mcollection-bar__item"));      
      $("#mormosaic .mcollection-bar__item").show();
      $("#mormosaic .mcollection-bar__item a[data-section='"+activestl+"']").parent("li").hide();
      $("#stlmore,#mormosaic").show();
      $('html,body').animate({scrollTop: 0},'slow');    
      return false;
    });

    if(getUrlParameter("look")!="") {
      activestl="topic_"+getUrlParameter("look");
	  $(".inspiration-mosaic").hide();
      $(".InspirationSection").hide();
      $("#"+activestl).show();
      
      $("#mormosaic").hide();
      mix($("#mormosaic .mcollection-bar__item"));
      $("#mormosaic .mcollection-bar__item").show();
      $("#mormosaic .mcollection-bar__item a[data-section='"+activestl+"']").parent("li").hide();
      $("#stlmore,#mormosaic").show();
      $('html,body').animate({scrollTop: 0},'slow');    
    }   
  }  
      
/* Delete sub categories and "Zeig mir alles!" from desktop menu */  
  $(".Linklist__Item").each(function() {
	menulink=$(this).find("a").text().slice(0, 1);
    if(menulink==">") {
      $(this).hide(); //remove();
    }
  })
  $(".MegaMenu__Inner a").each(function() {
	menulink=$(this).text();
    if(menulink=="Zeig mir alles!")
      $(this).parent().remove();
  })
/* Webcode search */  
  $("#Search .Search__Input").on("input", function(event) {   
    lastItem =$("#Search .Search__Input").val();
    if(products[lastItem]!==undefined) {
	  event.stopImmediatePropagation();
	  $("#Search").attr("aria-hidden","true");
      location.href="/products/"+products[lastItem];
    }
/* statistics: instant search */
    hmf_query=lastItem;
    window.hc_tm = window.hc_tm || [];
    window.hc_tm.push({"e":"track","ni":"0","p":{
    "page_type":hmf_pagetype,
    "event_type":"search_products", /* fixed value */
    "search_query":hmf_query,
    "hid":hmf_hid,
    "hem":hmf_hem,
    "language":hmf_language
    }});  
  });

  $("body").on("form.usf-is-inputbox input", function(event) {   
    lastItem=$("form.usf-is-inputbox input").val();
    if(products[lastItem]!==undefined) {
	  event.stopImmediatePropagation();
	  $(".usf-is-content").hide();
      location.href="/products/"+products[lastItem];
    }
  });

/* Activate OpenStreetMap */  
  if($("#osm").length) show_osm(); 

/* Special additions (neu eingetroffen / Labels) */  
  function showhide_sections() {
    /* "Neu eingetroffen" in other sections if sortby = created */  
    $("#usf-new-sortbtn").show();

    $("nav.breadcrumb a.newin").remove();
    if(
      getUrlParameter('sort_by')=="created-descending" ||
      getUrlParameter('usf_sort')=="-date"
    ) {
      $("nav.breadcrumb").append('<a href="#" class="newin">NEU EINGETROFFEN</a>');
      $(".newlabel").show();
      $("#usf-new-sortbtn").hide();
      $(".Pagination__Nav").empty();
    }
    
    /* Hide slideshows if label is selected */  
    var filtervendor = getUrlParameter('filter.p.vendor');
	if(!filtervendor) filtervendor=getUrlParameter('uff_7gfhxk_vendor');    
	if(!filtervendor) filtervendor=getUrlParameter('uff_1fntq1_vendor');
	if(!filtervendor) filtervendor=getUrlParameter('q');
	if(!filtervendor) filtervendor=getUrlParameter('sort_by');
	if(!filtervendor) filtervendor=getUrlParameter('usf_sort');    
    
    $(".shopify-section--collection-list,.shopify-section--slideshow").show();
    $(".conditionalimage section[data-conditional]").hide();

	if(getUrlParameter('uff_2aw7po_collections')!="" &&
       $('meta[property="og:title"]').attr("content")=="Sale"
    ) $(".shopify-section--collection-list").hide();     
    
    if(filtervendor) {
      $(".shopify-section--collection-list,.shopify-section--slideshow").hide();
      filtervendor=filtervendor.replace("&","%26");
      if($(".conditionalimage section[data-conditional='"+filtervendor+"'] .SEOdescription").length) {      
        $(".conditionalimage section[data-conditional='"+filtervendor+"']").show();
        SEOhtml=$(".conditionalimage section[data-conditional='"+filtervendor+"'] .SEOdescription").html();
        if(SEOhtml!="") {
          $("#_usf_prestige_main").parent().find(".SEOsection").remove();
          $("#_usf_prestige_main").parent().append('<footer class="SEOsection"><div class="Container"><div class="SectionHeader SectionHeader--center"><div class="SectionHeader__Description Rte" id="SEOlabel" name="SEOlabel">'+SEOhtml+'</div></div></div></footer>');      
          SEOtitle=$(".conditionalimage section[data-conditional='"+filtervendor+"'] .SEOtitle").text();
          SEOmeta=$(".conditionalimage section[data-conditional='"+filtervendor+"'] .SEOmeta").text();
          $("head meta[name=description]").remove();
          $("head").prepend('<meta name="description" content="'+SEOmeta+'" />');
          $("head title").remove();
          $("head").prepend("<title>"+SEOtitle+"</title>"); 
          $("head meta[name='twitter:description']").remove();
          $("head").append('<meta name="twitter:description" content="'+SEOmeta+'" />');
          $("head meta[property='og:description']").remove();
          $("head").append('<meta property="og:description" content="'+SEOmeta+'" />');
          SEOtable();
          /* Scroll to anchor inside page */
          $("a[href^='#']").on("click", function(e){
            anchorname=$(this).attr("href").substring(1);
            headerheight=$("#section-header").height();
            headerheight+=20;
            if(anchorname) anchorpos=$("[id='"+anchorname+"']").offset().top;
            else anchorpos=0;
            $('html,body').animate({scrollTop: (anchorpos-headerheight)},'slow');
            return false;
          })
        }
      }          
    } 
    
    if($('meta[property="og:title"]').attr("content")=="Sale") {
      $(".ProductList .usf-sr-product .ProductItem__Label.Heading").each(function(){
        if($(this).text()=="Im Angebot") {
		  productinfo=$(this).parent(".ProductItem__LabelList").next(".ProductItem__Info");
          np=parseFloat(productinfo.find(".Price--highlight").text().replace(",",".").replace(/[^0-9\.]+/g,""));
          ap=parseFloat(productinfo.find(".Price--compareAt").text().replace(",",".").replace(/[^0-9\.]+/g,""));
          diff=ap-np;
          proz=Math.round(diff/ap*100);
          // console.log(diff+" - "+proz);
          if(proz>4) $(this).text("Ersparnis: "+proz+"%");
        }
      });
    }
  }
  
/* Update filters */  
  function updatecatlist() {
    showhide_sections();
    synccatlist();
  }
  updatecatlist();

  function hiddencatlist() {
    advancedmenu='';
    advancedmenutopics=[];
  
/* Create hidden submenu packs */
    membase="";
    if($(".MegaMenu ul a.Link.Link--secondary").length) {
      $(".MegaMenu ul a.Link.Link--secondary").each(function() {
        if($(this).attr("href").indexOf("/collection")==0) {
          if($(this).is(":visible")) {
            membase=$(this).attr("href");
            $("body").append("<section class='hidden submenu' data-base='"+membase+"'></section>");
          } else {
            $("section[data-base^='"+membase+"']").append($(this).prop("outerHTML").replace(">&gt; ",">"));
          }
        }
      });
    }
  
/* Extended hidden categories sidebar menu */
    pagetitle=$('meta[property="og:title"]').attr("content")+"";
    pageurl=$('meta[property="og:url"]').attr("content")+"";
    pagehandle="/collections"+pageurl.substring(pageurl.lastIndexOf('/'));
    //if(getUrlParameter("filter.p.vendor")!="" ||
    if(pageurl.indexOf("/vendors?")>0) {
  	$(".Hiddencatlist").remove();
      return false;
    }
    pagetitle=pagetitle.toLowerCase();
    filtergender="undefined";
    basedir="";
    if($(".Hiddencatlist").length || $("#usf_container").length) {
      if(pagetitle.indexOf("frauen")>-1) filtergender = "frauen";
      if(pagetitle.indexOf("männer")>-1) filtergender = "manner";      
      $(".Hiddencatlist ul.Linklist li").remove();
      basedir=$(".Hiddencatlist").data("basedir");
      if(!basedir && pagehandle && $("#section-header nav.Header__MainNav ul li a.Heading[href$='"+pagehandle+"']").length)
        basedir=pagehandle;
      else if(!basedir && pagehandle && $("#section-header nav.Header__MainNav ul li a.Link--secondary[href$='"+pagehandle+"']").length)
        basedir=pagehandle;    
  	if(pagetitle=="männer" || pagetitle == "frauen") basedir="";
      
      if($("section.hidden.submenu[data-base='"+pagehandle+"']").length) {
        basefind=$("section.hidden.submenu[data-base='"+pagehandle+"'] a");
      } else if(basedir) {
        base=$("#section-header nav.Header__MainNav ul li a[href$='"+basedir+"']").next("ul.Linklist");   
        basefind=base.find("a.Link.Link--secondary:visible");     
      } else {      
        base=$("#section-header nav.Header__MainNav ul li a.Heading[href$='/"+filtergender+"']").next(".MegaMenu");   
        basefind=base.find("div:first div ul a.Link.Link--secondary:visible");
      }
        
      basefind.each(function() {
          linktext=$(this).text();
          linkhref=$(this).attr("href");
          linkimg=$(this).attr("data-image");
          linkcoll=linkhref.replace(/(^.*)\/([a-z_-]+$)/i,"$2");
          if(linktext!="NEU EINGETROFFEN" &&
             linkhref.indexOf("/vendors?")<0 &&
             linkhref.indexOf("filter.p.vendor")<0 &&
             linkhref.indexOf("uff_7gfhxk_vendor")<0 &&
             linkhref.indexOf("uff_1fntq1_vendor")<0
          ) {
            $(".Hiddencatlist ul.Linklist").append('<li class="Linklist__Item"><a href="'+linkhref+'" data-image="'+linkimg+'">'+linktext+'</a></li>');
            advancedmenu+='<button class=" usf-btn usf-relative usf-facet-value usf-facet-value-single"><!----> <!----> <span class="usf-label usf-btn"><a href="'+linkhref+'" data-image="'+linkimg+'">'+linktext+'</a></span> <!----></button>';       
            advancedmenutopics.push(linktext);
          }
      });
      
      if($("#usf_container").length && advancedmenu!="") {
  	  advancedmenu='<div class="usf-facet usf-collapsed togglethis hidden" data-section="catlist"><div class="usf-clear"><div class="usf-title usf-no-select"><button aria-label="Filter by MegaMenu" class="usf-label usf-btn">Kategorie</button> <!----> <!----> <span class="usf-pm"></span></div></div> <div class="usf-container"><!----><div class="usf-facet-values usf-scrollbar usf-facet-values--List">'+advancedmenu+'</div> <!----></div></div>';      
  	  $("#usf_container .CollectionInner__Sidebar .usf-facets__body").prepend(advancedmenu);
      }
      synccatlist();
      
      if($(".Hiddencatlist .Linklist__Item").length==0) {
        $(".Hiddencatlist").remove();
        return false;
      }       
    }
  }
  hiddencatlist();   

/* Clone sub categories menu to responsive view */
  // advanced filter system
  if($("#usf_container").length) {   
	$("body").on("click","button[data-drawer-id='usf-collection-filter-drawer']",function(){   
      window.setTimeout(function() {
        synccatlist();
      },500);           
  	});
  } else {
  // regular filter system
    var filtervendor = getUrlParameter('filter.p.vendor');
    if(filtervendor && $(".Genderlist").length) {
      $(".Genderlist a").each(function() {
        link=$(this).attr("href")+encodeURIComponent(filtervendor);
        $(this).attr("href",link);
      })
    }
    $(".Catlist").clone().prependTo("#collection-filters-drawer-form");
  }

  function reordersizes() {  
/* Reorder sizes */
    my_option = "größe";
    my_order  = "XXS,XS,XS/32,XS/S,S,S/32,S/M,M,M/32,M/L,ML,L,L/XL,XL,XL/32,XXL,2XL,XXXL,3XL,XXXXL,4XL";
      
    my_order=my_order.replace(/ l/gi,".0");
    my_order=my_order.replace(/ k/gi,".0");
    my_order=my_order.replace(/ ol/gi,".0");    
    my_order=my_order.replace(/ reg/gi,".0");
    my_order=my_order.replace(/ /g,".0");
    my_order=my_order.replace(/\/l/gi,".0");   
    my_order=my_order.replace(/\/ol/gi,".0");   
    my_order=my_order.replace(/\/reg/gi,".0");   
    my_order=my_order.replace(/\//g,".0");
    //my_order=my_order.replace(/0+/g,"0");
    my_order=my_order.replace(/\.0\.0/g,".0");   
    my_order=my_order.replace(/'/g,"");       
    my_order=my_order.replace(/inch/gi,"");   
    my_order=my_order.replace(/\.short/gi,".0");
  
    my_order_array=my_order.toLowerCase().split(',').reverse();
  
    // sizes in desktop menu
    eleval=[];
    inner=$("#usf_container .usf-facets-container .usf-facets__body .usf-title button[aria-label$='Größe']");      
    inner=inner.parents(".usf-facet");
    innerli=inner.find(".usf-container .usf-facet-values--List");
    innerli.find("button").each(function(){
      objval=$(this).find(".usf-label").text();
      objval+="";objval=objval.toLowerCase();

      objval=objval.replace(/ l/gi,".0");
      objval=objval.replace(/ k/gi,".0");
      objval=objval.replace(/ ol/gi,".0");    
      objval=objval.replace(/ reg/gi,".0");
      objval=objval.replace(/ /g,".0");
      objval=objval.replace(/\/l/gi,".0");   
      objval=objval.replace(/\/ol/gi,".0");   
      objval=objval.replace(/\/reg/gi,".0");   
      objval=objval.replace(/\//g,".0");
      objval=objval.replace(/\.0\.0/g,".0");     
      objval=objval.replace(/'/g,"");       
      objval=objval.replace(/inch/gi,"");
      objval=objval.replace(/\.short/gi,".0");

      if(objval.match(/^3\d3\d$/)) objval=objval.substring(0,2)+".0"+objval.substring(2);
    
      if(!$(this).attr("reorder") || $(this).attr("reorder")=="") {
        $(this).attr("reorder",objval);
      }
      eleval.push(objval);
    })  
    eleval=natsort(eleval).reverse();
    $(eleval).each(function(key,val) {
      selval=$('#usf_container [reorder="'+val+'"]');
      if(selval.length) selval.detach().prependTo(innerli);
    })
    $(my_order_array).each(function(key,val) {
      selval=$('#usf_container [reorder="'+val+'"]');
      if(selval.length) selval.detach().prependTo(innerli);          
    });
  
    // sizes in mobile menu
    eleval=[];
    inner=$(".usf-sr-filters .usf-facets-wrapper .usf-facets__body .usf-title button[aria-label$='Größe']");          
    inner=inner.parents(".usf-facet");
    innerli=inner.find(".usf-container .usf-facet-values--List");
    innerli.find("button").each(function(){
      objval=$(this).find(".usf-label").text();
      objval+="";objval=objval.toLowerCase();

      objval=objval.replace(/ l/gi,".0");
      objval=objval.replace(/ k/gi,".0");    
      objval=objval.replace(/ ol/gi,".0");    
      objval=objval.replace(/ reg/gi,".0");
      objval=objval.replace(/ /g,".0");
      objval=objval.replace(/\/l/gi,".0");   
      objval=objval.replace(/\/ol/gi,".0");   
      objval=objval.replace(/\/reg/gi,".0");   
      objval=objval.replace(/\//g,".0");
      objval=objval.replace(/\.0\.0/g,".0");     
      objval=objval.replace(/'/g,"");
      objval=objval.replace(/inch/gi,"");
      objval=objval.replace(/\.short/gi,".0");
          
      if(objval.match(/^3\d3\d$/)) objval=objval.substring(0,2)+".0"+objval.substring(2);
          
      if(!$(this).attr("reorder") || $(this).attr("reorder")=="") {
        $(this).attr("reorder",objval);
      }
      eleval.push(objval);
    })  
    eleval=natsort(eleval).reverse();
    $(eleval).each(function(key,val) {
      selval=$('.usf-sr-filters .usf-facets-wrapper  [reorder="'+val+'"]');
      if(selval.length) selval.detach().prependTo(innerli);
    })
    $(my_order_array).each(function(key,val) {
      selval=$('.usf-sr-filters .usf-facets-wrapper  [reorder="'+val+'"]');
      if(selval.length) selval.detach().prependTo(innerli);          
    });
    
    // sizes on product page  
    $(".Popover .Popover__Header span").each(function(){
      if($(this).text().indexOf("Größe")>-1) {
       eleval=[];
        inner=$(this).parents(".Popover");
        innerli=inner.find(".Popover__Content").find(".Popover__ValueList");
        innerli.find("button").each(function(){
          objval=$(this).data("value");
          objval+="";objval=objval.toLowerCase();        

          objval=objval.replace(/ l/gi,".0");
          objval=objval.replace(/ k/gi,".0");        
          objval=objval.replace(/ ol/gi,".0");    
          objval=objval.replace(/ reg/gi,".0");
          objval=objval.replace(/ /g,".0");
          objval=objval.replace(/\/l/gi,".0");   
          objval=objval.replace(/\/ol/gi,".0");   
          objval=objval.replace(/\/reg/gi,".0");   
          objval=objval.replace(/\//g,".0");
          objval=objval.replace(/\.0\.0/g,".0");        
          objval=objval.replace(/'/g,"");       
          objval=objval.replace(/inch/gi,"");           
          objval=objval.replace(/\.short/gi,".0");
                  
          if(objval.match(/^3\d3\d$/)) objval=objval.substring(0,2)+".0"+objval.substring(2);
            
          if(!$(this).attr("reorder") || $(this).attr("reorder")=="") {
            $(this).attr("reorder",objval);          
          }
  		eleval.push(objval);
        })
        eleval=natsort(eleval).reverse();
        $(eleval).each(function(key,val) {
          selval=inner.find("button[reorder='"+val+"']");                                        
          if(selval.length) selval.detach().prependTo(innerli);          
        })      
        $(my_order_array).each(function(key,val) {
          selval=inner.find('.Popover__Content .Popover__ValueList button[reorder="'+val+'"]');
          if(selval.length) selval.detach().prependTo(innerli);          
        })
      }
    });
  }  
  reordersizes(); 

/* Change text color selector to colored points */
  function filtermagic() {   
  /* Show color on product page */
    $(".ProductForm__Option button[aria-controls$='__main-suchfarbe'] span.ProductForm__SelectedValue").each(function() {
  	//$(this).parent("li").addClass("colorselector");
      thiscolor=$(this).text();
      thiscolor_handle=thiscolor.toLowerCase().replace(/[^a-z]+/g,"");   
  	$(this).parents(".ProductForm__Option").find(".colorselector").parent("ul.Linklist").remove();    
      $(this).parents(".ProductForm__Option").append('<ul class="Linklist"><li class="Linklist__Item colorselector"><label class="Text--subdued Link Link--primary colorselector_'+thiscolor_handle+'" title="'+thiscolor+'" itemprop="'+thiscolor+'">'+thiscolor+'</label></li></ul>');
    })
  }
  filtermagic();

/* After filter refresh */
  $(".LoadingBar").on('transitionend', function(e){
    reordersizes();
    filtermagic();
	updatecatlist();
  $(window).trigger("resize");  
  })
  usf.event.add('sr_updated', function(){
    window.setTimeout(function() {    

      /* statistics: products list */
      hmf_cname="";
      hmf_pid="";
      hmf_pname="";
      hmf_pprice="";
      //$("nav.breadcrumb a").each(function() {
      //  hmf_cname+=","+$(this).text().trim();
      //})
      hmf_cname=$("nav.breadcrumb a").last().text().trim();
      // Suchergebnisse
      $(".usf-sr-product").each(function() {
        hmf_pid+=","+$(this).data("usf-pid");
        tmp_pname=$(this).find("h2.ProductItem__Title a").text().trim();
        if(tmp_pname.includes(",")) tmp_pname='"'+tmp_pname+'"';
        hmf_pname+=","+tmp_pname; 
        hmf_pprice+=","+$(this).find(".ProductItem__Price").eq(0).text().replace("€","").replace(",",".");
      })
      // zuletzt angesehen
      $("section[data-section-type='recently-viewed-products'] .Carousel__Cell").each(function() {
        hmf_pid+=","+$(this).data("pid");
        tmp_pname=$(this).find("h2.ProductItem__Title a").text().trim();
        if(tmp_pname.includes(",")) tmp_pname='"'+tmp_pname+'"';
        hmf_pname+=","+tmp_pname; 
        hmf_pprice+=","+$(this).find(".ProductItem__Price").eq(0).text().replace("€","").replace(",","."); 
      })
      
      hmf_cname=hmf_cname.replace(/^,/,"");
      hmf_pid=hmf_pid.replace(/^,/,"");
      hmf_pname=hmf_pname.replace(/^,/,"");
      hmf_pprice=hmf_pprice.replace(/^,/,"");
      //if(hmf_cname.includes("Labels,")) {hmf_cname=hmf_cname.replace("Labels,","");hmf_pagetype="label";}
      //if(hmf_cname.includes(",")) hmf_pagetype="sub_category";
      
      if(hmf_cname=="") {
        window.hc_tm = window.hc_tm || [];
        window.hc_tm.push({"e":"track","ni":"1","p":{
        "page_type":hmf_pagetype,
        "event_type":"product_list_view", /* fixed value */
        "product_list_name":"Collection",
        "product_group_id":hmf_pid,
        "product_name":hmf_pname,
        "product_price":hmf_pprice,
        "currency":hmf_currency,
        "hid":hmf_hid,
        "hem":hmf_hem,
        "language":hmf_language
        } });
      } else {
        window.hc_tm = window.hc_tm || [];
        window.hc_tm.push({"e":"track","ni":"1","p":{
        "page_type":hmf_pagetype,
        "event_type":"product_list_view", /* fixed value */
        "product_list_name":"Collection",
        "product_group_id":hmf_pid,
        "product_name":hmf_pname,
        "product_price":hmf_pprice,
        "category_name":hmf_cname,
        "currency":hmf_currency,
        "hid":hmf_hid,
        "hem":hmf_hem,
        "language":hmf_language
        } });      
      } 
// --- not available variables ---
// "category_id":"__category_id__",
    
      reordersizes();
	  updatecatlist();

      params = new URLSearchParams(window.location.search);
      hmf_query=params.get("q");      
      if(!$("#Search .Search__Input").val() && !hmf_query) {
      
      /* statistics: filter changed */      
        window.hc_tm = window.hc_tm || [];
        window.hc_tm.push({"e":"track","p":{
        "page_type":"category", /* fixed value */
        "event_type":"filter_products", /* fixed value */
        "hid":hmf_hid,
        "hem":hmf_hem,
        "language":hmf_language
        } });
      }           
      
      $(window).trigger("resize"); 
    },300);
  });

/* statistics: cart list */ 
  var observer = new MutationObserver(function(mutations) {   
    if($("#sidebar-cart").attr("aria-hidden")=="false")
    cartview();
  });
  var target = document.querySelector('#sidebar-cart');observer.observe(target, {attributes: true});  

  // $(document).on("click","a[href='/cart']", function(){cartview();});
  if($("nav.breadcrumb a").length==0 && $("h1.SectionHeader__Heading.Heading.u-h1").text().trim()=="Warenkorb") cartview();

  function cartview() {
    hmf_cname="";
    hmf_pid="";
    hmf_pname="";
    hmf_pprice="";
    hmf_pquantity="";
    hmf_amount=0;
    // $("nav.breadcrumb a").each(function() {
    //   hmf_cname+=","+$(this).text().trim();
    // })
    // hmf_cname=hmf_cname.replace(/^,/,"");
    hmf_cname=$("nav.breadcrumb a").last().text().trim();
    if(hmf_cname=="" && $("h1.SectionHeader__Heading.Heading.u-h1").text().trim()=="Warenkorb")hmf_cname="Warenkorb";
    $(".Cart .CartItem__Info").each(function() {
      hmf_pid+=","+$(this).find("h2.CartItem__Title a").attr("href").replace(/^.*variant=/,"");
      tmp_pname=$(this).find("h2.CartItem__Title a").text().trim();
      if(tmp_pname.includes(",")) tmp_pname='"'+tmp_pname+'"';
      hmf_pname+=","+tmp_pname; 
      hmf_pprice+=","+$(this).find(".CartItem__Price").eq(0).text().replace("€","").replace(",",".");
      hmf_amount+=parseFloat($(this).find(".CartItem__Price").eq(0).text().replace("€","").replace(",","."));
      hmf_pquantity+=","+$(this).find(".QuantitySelector__CurrentQuantity").val();
    })
    hmf_cname=hmf_cname.replace(/^,/,"");
    hmf_pid=hmf_pid.replace(/^,/,"");
    hmf_pname=hmf_pname.replace(/^,/,"");
    hmf_pprice=hmf_pprice.replace(/^,/,"");
    hmf_pquantity=hmf_pquantity.replace(/^,/,"");  
    hmf_amount=hmf_amount.toFixed(2);

    window.hc_tm = window.hc_tm || [];
    window.hc_tm.push({"e":"track","ni":"1","p":{
    "page_type":"cart", /* fixed value */
    "event_type":"cart_view", /* fixed value */
  
    "product_id":hmf_pid,
    "product_name":hmf_pname,
    "product_price":hmf_pprice,
    "product_quantity":hmf_pquantity,
    "amount":hmf_amount,
    "currency":hmf_currency,
    "hid":hmf_hid,
    "hem":hmf_hem,
    "language":hmf_language
    } });
    // --- not available variables ---
    // "category_id":"__category_id__",      
    // "category_name":hmf_cname,
  }
  
/* statistics: start checkout */
  $(document).on("click",".Cart .Cart__Checkout", function(){
    hmf_cname="";
    hmf_pid="";
    hmf_pname="";
    hmf_pprice="";
    hmf_pquantity="";
    hmf_amount=0;
    // $("nav.breadcrumb a").each(function() {
    //   hmf_cname+=","+$(this).text().trim();
    // })
    // hmf_cname=hmf_cname.replace(/^,/,"");
    hmf_cname=$("nav.breadcrumb a").last().text().trim();  
    if(hmf_cname=="" && $("h1.SectionHeader__Heading.Heading.u-h1").text().trim()=="Warenkorb")hmf_cname="Warenkorb";
    $(".Cart .CartItem__Info").each(function() {
      hmf_pid+=","+$(this).find("h2.CartItem__Title a").attr("href").replace(/^.*variant=/,"");
      tmp_pname=$(this).find("h2.CartItem__Title a").text().trim();
      if(tmp_pname.includes(",")) tmp_pname='"'+tmp_pname+'"';
      hmf_pname+=","+tmp_pname; 
      hmf_pprice+=","+$(this).find(".CartItem__Price").eq(0).text().replace("€","").replace(",",".");
      hmf_amount+=parseFloat($(this).find(".CartItem__Price").eq(0).text().replace("€","").replace(",","."));
      hmf_pquantity+=","+$(this).find(".QuantitySelector__CurrentQuantity").val();
    })
    hmf_cname=hmf_cname.replace(/^,/,"");
    hmf_pid=hmf_pid.replace(/^,/,"");
    hmf_pname=hmf_pname.replace(/^,/,"");
    hmf_pprice=hmf_pprice.replace(/^,/,"");
    hmf_pquantity=hmf_pquantity.replace(/^,/,"");  
    hmf_amount=hmf_amount.toFixed(2);
  
    window.hc_tm = window.hc_tm || [];
    window.hc_tm.push({"e":"track","p":{
    "page_type":"checkout", /* fixed value */
    "event_type":"begin_checkout", /* fixed value */ 
    "product_id":hmf_pid,
    "product_name":hmf_pname,
    "product_price":hmf_pprice,
    "product_quantity":hmf_pquantity,
    "amount":hmf_amount,
    "amount_before_discount":hmf_amount,
    "currency":hmf_currency,
    "hid":hmf_hid,
    "hem":hmf_hem,
    "language":hmf_language
    } });
    // --- not available variables ---
    // "category_id":"__category_id__",      
    // "category_name":hmf_cname,
  })
  
/* statistics: change quantity */
  $(document).on("click",".CartItem .QuantitySelector .QuantitySelector__Button:last-child", function() {
    hmf_cname="";
    // $("nav.breadcrumb a").each(function() {
    //   hmf_cname+=","+$(this).text().trim();
    // })
    // hmf_cname=hmf_cname.replace(/^,/,"");
    hmf_cname=$("nav.breadcrumb a").last().text().trim();
    productblock=$(this).parents(".CartItem__Info");
    hmf_pname = productblock.find("h2.CartItem__Title a").text();
    hmf_pid = productblock.find("h2.CartItem__Title a").attr("href").replace(/^.*variant=/,"");
    hmf_pprice = productblock.find(".CartItem__Price").text().replace("€","").replace(",",".");
    hmf_pquantity = productblock.find(".QuantitySelector__CurrentQuantity").val();
    // hmf_pagetype="top_category";
    // if(hmf_cname.includes("Labels,")) {hmf_cname=hmf_cname.replace("Labels,","");hmf_pagetype="label";}
    // if(hmf_cname.includes(",")) hmf_pagetype="sub_category";
    
    window.hc_tm = window.hc_tm || [];
    window.hc_tm.push({"e":"track","p":{
    "page_type":"product", /* fixed value */
    "event_type":"add_to_cart", /* fixed value */
    "category_name":hmf_cname,   
    "product_group_id":hmf_pid,
    "product_name":hmf_pname,
    "product_price":hmf_pprice,
    "product_quantity":hmf_pquantity,
    "currency":hmf_currency,
    "hid":hmf_hid,
    "hem":hmf_hem,
    "language":hmf_language
    } });
    // --- not available variables ---
    // "category_id":"__category_id__",                 
  })
  
/* statistics: item deleted */
  $(document).on("click",".CartItem .QuantitySelector > .QuantitySelector__Button:first-child,.CartItem__Remove", function() {
    hmf_cname="";
    // $("nav.breadcrumb a").each(function() {
    //   hmf_cname+=","+$(this).text().trim();
    // })
    // hmf_cname=hmf_cname.replace(/^,/,"");
    hmf_cname=$("nav.breadcrumb a").last().text().trim();
    productblock=$(this).parents(".CartItem__Info");
    hmf_pname = productblock.find("h2.CartItem__Title a").text();
    hmf_pid = productblock.find("h2.CartItem__Title a").attr("href").replace(/^.*variant=/,"");
    hmf_pprice = productblock.find(".CartItem__Price").text().replace("€","").replace(",",".");
    hmf_pquantity = productblock.find(".QuantitySelector__CurrentQuantity").val();
    // hmf_pagetype="top_category";
    // if(hmf_cname.includes("Labels,")) {hmf_cname=hmf_cname.replace("Labels,","");hmf_pagetype="label";}
    // if(hmf_cname.includes(",")) hmf_pagetype="sub_category";
    
    window.hc_tm = window.hc_tm || [];
    window.hc_tm.push({"e":"track","p":{
    "page_type":hmf_pagetype, /* replace with the actual page type */
    "event_type":"remove_from_cart", /* fixed value */
    "product_id":hmf_pid,
    "product_name":hmf_pname,
    "product_price":hmf_pprice,
    "product_quantity":hmf_pquantity,
    "currency":hmf_currency,
    "hid":hmf_hid,
    "hem":hmf_hem,
    "language":hmf_language
    } });
    // --- not available variables ---
    // "category_name":hmf_cname,   
    // "category_id":"__category_id__",                 
  })
    
/* Rearrange labels list to grid on labels page */
  labellist();

/* Create logo slider layout from filter */
  logobar();
  collectionbar();
  SEOtable();  

/* Scroll to anchor inside page */
  $("a[href^='#']").on("click", function(e){
    anchorname=$(this).attr("href").substring(1);
    headerheight=$("#section-header").height();
    headerheight+=20;
	if(anchorname) anchorpos=$("[id='"+anchorname+"']").offset().top;
    else anchorpos=0;
    $('html,body').animate({scrollTop: (anchorpos-headerheight)},'slow');
    return false;
  })
  
/* Activate logo slider */
  if((slidewidth*totalslides)>$(".logo-bar__list").width()) {
	$("#logo-bar").append("<div class='go_prev flickity-prev-next-button previous'><svg viewBox='0 0 100 100'><path d='M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z' class='arrow'></path></svg></div><div class='go_next flickity-prev-next-button next'><svg viewBox='0 0 100 100'><path d='M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z' class='arrow' transform='translate(100, 100) rotate(180) '></path></svg></div>");

    space=(($("#logo-bar").width()-$(".logo-bar__list").width())/2)-50;
    if(space<10) space=10; 
    $("#logo-bar .go_prev").css("left",space+"px");
    $("#logo-bar .go_next").css("right",space+"px");    
  }
  if(currentslide==finalslide) $(".go_next").hide();
  if(currentslide==0) $(".go_prev").hide();
    
  $("body").on("click","#logo-bar .go_next", function(){
    clearTimeout(logobartime);
    logobardirection=-1;
    if(currentslide<finalslide) {
      $(".logo-bar__item").eq(currentslide+screenslides).width(0).animate({width:slidewidth});
      $(".logo-bar__item").eq(currentslide).width(slidewidth).animate({width:0});
  	currentslide++;
      if(currentslide==finalslide) $(this).hide(); else $(this).show();
      if(currentslide>0) $("#logo-bar .go_prev").show();
    }
    logobartime=setTimeout(logobartimer,3000);
  })
  $("body").on("click","#logo-bar .go_prev", function(){
    clearTimeout(logobartime);
    logobardirection=1;
    if(currentslide>0) {
      $(".logo-bar__item").eq(currentslide-1+screenslides).width(slidewidth).animate({width:0});
      $(".logo-bar__item").eq(currentslide-1).width(0).animate({width:slidewidth});
  	currentslide--;
      if(currentslide==0) $(this).hide(); else $(this).show();
      if(currentslide<finalslide) $("#logo-bar .go_next").show();
    }
    logobartime=setTimeout(logobartimer,3000);
  })
  if($("#logo-bar").is(":visible"))
    logobartime=setTimeout(logobartimer,3000);

/* Activate collection slider */
  collection_totalslides = $("ul.collection-bar__list li").length;
  collection_slidewidth  = $(".collection-bar__item").width();
  collection_currentslide= 0;
  collection_screenslides= $(".collection-bar__list").width()/collection_slidewidth;

  if($("#collection-bar.image-mosaic").length) {
    if(collection_screenslides<collection_totalslides) {
    widthset=1;
    for(i=collection_screenslides;i>0;i--) {
      if(collection_totalslides % i == 0) {
        if(widthset==1)widthset=i;
      }
    }
    $("#collection-bar.image-mosaic .collection-bar__list").css("max-width",widthset * collection_slidewidth); 
    return true;
    }  
  }
  
  collection_finalslide  = collection_totalslides - collection_screenslides;
  if((collection_slidewidth*collection_totalslides)>$(".collection-bar__list").width()) {
	$("#collection-bar").append("<div class='go_prev flickity-prev-next-button previous'><svg viewBox='0 0 100 100'><path d='M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z' class='arrow'></path></svg></div><div class='go_next flickity-prev-next-button next'><svg viewBox='0 0 100 100'><path d='M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z' class='arrow' transform='translate(100, 100) rotate(180) '></path></svg></div>");

    space=(($("#collection-bar").width()-$(".collection-bar__list").width())/2)-50;
    if(space<10) space=10; 
    $("#collection-bar .go_prev").css("left",space+"px");
    $("#collection-bar .go_next").css("right",space+"px");  
  }
  if(collection_currentslide==collection_finalslide) $("#collection-bar .go_next").hide();
  if(collection_currentslide==0) $("#collection-bar .go_prev").hide();
  
  $("#collection-bar").on("click",".go_next", function(){
    if(collection_currentslide<collection_finalslide) {
      $(".collection-bar__item").eq(collection_currentslide+collection_screenslides).width(0).animate({width:collection_slidewidth});
      $(".collection-bar__item").eq(collection_currentslide).width(collection_slidewidth).animate({width:0});
  	collection_currentslide++;
      if(collection_currentslide==collection_finalslide) $(this).hide(); else $(this).show();
      if(collection_currentslide>0) $("#collection-bar .go_prev").show();
    }
  })
  $("#collection-bar").on("click",".go_prev", function(){
    if(collection_currentslide>0) {
      $(".collection-bar__item").eq(collection_currentslide-1+collection_screenslides).width(collection_slidewidth).animate({width:0});
      $(".collection-bar__item").eq(collection_currentslide-1).width(0).animate({width:collection_slidewidth});
  	collection_currentslide--;
      if(collection_currentslide==0) $(this).hide(); else $(this).show();
      if(collection_currentslide<collection_finalslide) $("#collection-bar .go_next").show();
    }
  })

  /* Change layout of product description */
  if($(".Product__Info .ProductMeta__Description .Rte").length) {
    $(".Product__Info .ProductMeta__Description .Rte ul b").each(function() {
  	$(this).replaceWith($('<strong>' + this.innerHTML + '</strong>'));
    });
    description=$(".Product__Info .ProductMeta__Description .Rte").html();
    description=description.replace(/<b>Suchfarbe.*<\/ul>/i,'');
    descpart = description.split("<b>");
    
    if(descpart[0].indexOf("<ul")==0) {    
  	descpart[0]="<b>Produktbeschreibung</b>"+descpart[0];    
    } else {
      if(descpart[0].indexOf("<p")<0)
        descpart[0]="<p>"+descpart[0]+"</p>";
      if(descpart[0].indexOf("<p></p>")>-1)
        descpart[0]=descpart[0].replace(/^<p><\/p>/,"");
      if(descpart[0]!="") descpart[0]="<b>Produktbeschreibung</b><ul><li>"+descpart[0]+"</li></ul>";
    }
      
    description=descpart.join("<b>");
  
    $(".Product__Info .ProductMeta__Description .Rte").html(description);
    $(".Product__Info .ProductMeta__Description .Rte b").wrap("<button type='button' class='Collapsible__Button Heading u-h6' data-action='toggle-collapsible' aria-expanded='true'></button>");
    $(".Product__Info .ProductMeta__Description .Rte ul").wrap("<div class='Collapsible__Inner'><div class='Collapsible__Content'></div>");
    $(".Product__Info .ProductMeta__Description .Rte button").append('<span class="Collapsible__Plus"></span>');
    $(".Product__Info .ProductMeta__Description .Rte ul").addClass("Linklist");
    $(".Product__Info .ProductMeta__Description .Rte ul li").addClass("Linklist__Item");
    description=$(".Product__Info .ProductMeta__Description .Rte").html();
    description=description.replace(/<\/?b>/g,'').replace(/<button/g,'<div class="Collapsible Collapsible--padded"><button').replace(/<\/ul>/g,'</ul></div>');
    $(".Product__Info .ProductMeta__Description .Rte").html(description);
  }

  marke=$(".ProductMeta__MoreVendor a").text(); 
  link=$(".ProductMeta__MoreVendor").attr("href"); 
  logo=marke.replace(/[^a-zA-Z]+/g, '').toLowerCase();
  markenhtml='<img src="https://cdn.shopify.com/s/files/1/0626/2688/9955/files/logo_'+logo+'.jpg?'+$.now()+'" alt="'+marke+'">';
  $(".ProductMeta__MoreVendor a").html(markenhtml); 
  
  baukasten = $('.Baukasten').detach();
  $(".ProductMeta__MoreVendor").after(baukasten);
  $(".Baukasten .product__img").css('min-height','150px').css('height','auto').height($(".Baukasten .product__img").width()/3*4);
  $(".section_baukasten").remove();
  
  showhide_sections(); 
  labellist();
});

$(window).on("resize", function(){
  synccatlist();
  $("#osm").height($(this).width()*.4375);
  $(".collection-bar__list").css("max-width","100%");
  clearTimeout(logobartime); 
  logobar();
  $(".Baukasten .product__img").height("auto").height($(".Baukasten .product__img").width()/3*4);
  $(".logo-bar__item").width(slidewidth);
  currentslide= 0;
  screenslides= $(".logo-bar__list").width()/slidewidth;
  finalslide  = totalslides - screenslides;
  $("#logo-bar .go_prev,#logo-bar .go_next").remove();
  if((slidewidth*totalslides)>$(".logo-bar__list").width()) {
	$("#logo-bar").append("<div class='go_prev flickity-prev-next-button previous'><svg viewBox='0 0 100 100'><path d='M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z' class='arrow'></path></svg></div><div class='go_next flickity-prev-next-button next'><svg viewBox='0 0 100 100'><path d='M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z' class='arrow' transform='translate(100, 100) rotate(180) '></path></svg></div>");
    
	space=(($("#logo-bar").width()-$(".logo-bar__list").width())/2)-50;
    if(space<10) space=10; 
    $("#logo-bar .go_prev").css("left",space+"px");
    $("#logo-bar .go_next").css("right",space+"px");
  }
  if(currentslide==finalslide) $("#logo-bar .go_next").hide();
  if(currentslide==0) $("#logo-bar .go_prev").hide();

  if($("#logo-bar").is(":visible"))
    logobartime=setTimeout(logobartimer,3000);  

  $(".collection-bar__item").width(collection_slidewidth);
  collection_currentslide= 0;
  collection_screenslides= $(".collection-bar__list").width()/collection_slidewidth;

  if($("#collection-bar.image-mosaic").length) {
    if(collection_screenslides<collection_totalslides) {
      widthset=1;
    for(i=collection_screenslides;i>0;i--) {
      if(collection_totalslides % i == 0) {
        if(widthset==1)widthset=i;
      }
    }
    $("#collection-bar.image-mosaic .collection-bar__list").css("max-width",widthset * collection_slidewidth); 
    return true;
    }  
  }  
    
  collection_finalslide  = collection_totalslides - collection_screenslides;
  $("#collection-bar .go_prev,#collection-bar .go_next").remove();
  if((collection_slidewidth*collection_totalslides)>$(".collection-bar__list").width()) {
	$("#collection-bar").append("<div class='go_prev flickity-prev-next-button previous'><svg viewBox='0 0 100 100'><path d='M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z' class='arrow'></path></svg></div><div class='go_next flickity-prev-next-button next'><svg viewBox='0 0 100 100'><path d='M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z' class='arrow' transform='translate(100, 100) rotate(180) '></path></svg></div>");

    space=(($("#collection-bar").width()-$(".collection-bar__list").width())/2)-50;
    if(space<10) space=10; 
    $("#collection-bar .go_prev").css("left",space+"px");
    $("#collection-bar .go_next").css("right",space+"px");
  }
  if(collection_currentslide==collection_finalslide) $("#collection-bar .go_next").hide();
  if(collection_currentslide==0) $("#collection-bar .go_prev").hide();  
  synccatlist();
  labellist();
});

/* Show/hide categories from advanced filters collections list */ 
function synccatlist() {
  if($("#usf_container").length) {
    inner=$("#usf_container button[aria-label$='Kategorie']");      
    inner=$(".usf-facets.usf-no-select.usf-zone.usf-sr-filters button[aria-label$='Kategorie']");
    inner=inner.parents(".usf-facet");
    if(advancedmenutopics.length || 1==1) {     
      innerli=inner; //.find(".usf-container .usf-facet-values--List");         
      innerli.find("button.usf-facet-value-multiple span.usf-label").each(function(){
        originallabel=$(this).text();
        label=originallabel.replace(/^FRAUEN /ig,"").replace(/^MÄNNER /ig,"");       
        $(this).text(label);
      });
      inner.show();
      
      /* Change collection on click in filter menu */
      innerli.find("button.usf-facet-value-multiple").off("click change").on("click change",function() {
        collectionname=$(this).find("span.usf-label").first().text();
        $("div[data-section='catlist'] .usf-container a").each(function() {
          if($(this).text()==collectionname) {
	        collectionlink=$(this).attr("href");
            if(collectionlink!="") {
              // $("body").fadeOut();
              location.href=collectionlink;
            }
          }
        })
      })
     
    } else {
      inner.hide();
    }
    
	inner.find(".usf-container .goback").remove();
    bread=$("nav.breadcrumb a");
    if(bread.length>1) {
      	parentlnk=bread.eq(bread.length-2).attr("href");
        parentnam=bread.eq(bread.length-2).text();
    	inner.find(".usf-container").prepend('<button class="goback usf-btn usf-relative usf-facet-value usf-facet-value-multiple" onclick="location.href=\''+parentlnk+'\'"><div class="usf-checkbox" style="margin-right:6px;"><span class="gobackicon"></span></div> <!----> <span class="usf-label usf-btn">'+parentnam+'</span> <!----></button>');
    }
    
  }
}

/* Logo slider */
function logobar() {

  vendorfilter="uff_1fntq1_vendor";
  currcollection=$(location).attr("pathname").replace("/collections","");
  currcollection=currcollection.replace(/\/$/g,"");
  
  if(currcollection=="/manner" || currcollection=="/manner-bekleidung" ||
     currcollection=="/frauen" || currcollection=="/frauen-bekleidung") {
	 vendorfilter="uff_7gfhxk_vendor";
  } else if(currcollection=="/vendors") {
	 vendorfilter="q";
  }  
  
  selfurl=$(location).attr("href")+"?";
  selfurl=selfurl.substr(0,selfurl.indexOf('?'));

  if($("#usf_container").length) {    
// advanced filter system    
	selmarken="";
    marken=$("#usf_container .usf-facets-container button[aria-label$='Marke']").parents(".usf-facet").find('.usf-container button .usf-label');           
    if($("button[aria-label$='Marke']").length && $(".usf-checkbox.usf-checked").length)
  	  selmarken=$("#usf_container .usf-facets-container button[aria-label$='Marke']").parents(".usf-facet").find(".usf-container .usf-selected .usf-label");
    if(selmarken) marken=selmarken;
  } else {
// regular filter system
    if($(".Genderlist").length && $(".CollectionInner input[name='filter.p.vendor']:checked").length)
  	  marken=$(".CollectionInner input[name='filter.p.vendor']:checked");
    else
      marken=$(".CollectionInner input[name='filter.p.vendor']");      
  } 

  $("#logo-bar").remove();
  if(marken.length) {
    markenhtml='<div id="logo-bar"><ul class="logo-bar__list">';
    marken.each(function(){
      if($(this).attr("value"))
        marke=$(this).attr("value")+"";
      else
        marke=$(this).text()+"";
      logo=marke.replace(/[^a-zA-Z]+/g, '').toLowerCase();
      if(logo!="modefunk") {      
        vendor=marke.replace(/\s/g,'+').replace(/[^+a-zA-Z]+/g,'');
        vendor=encodeURIComponent(marke);
        markenhtml=markenhtml+'<li class="logo-bar__item"><a href="'+selfurl+'?'+vendorfilter+'='+vendor+'">';
        markenhtml=markenhtml+'<img src="https://cdn.shopify.com/s/files/1/0626/2688/9955/files/logo_'+logo+'.jpg?'+$.now()+'" alt="'+marke+'">';
        markenhtml=markenhtml+'</a></li>';
      } else
        $(this).remove();
    })
    markenhtml=markenhtml+'</ul></div>';
    if($("#SEOlinks").length)
      $("#SEOlinks").first().before(markenhtml);        
    else
  	  $(".shopify-section.shopify-section--bordered").first().before(markenhtml);        
  }
  totalslides = $("ul.logo-bar__list li").length;
  slidewidth  = $(".logo-bar__item").width();
  currentslide= 0;
  screenslides= $(".logo-bar__list").width()/slidewidth;
  finalslide  = totalslides - screenslides;  
  synccatlist();
}
function logobartimer() {
  if(logobardirection==-1 && currentslide>=finalslide)
    logobardirection=1;
  if(logobardirection==1 && currentslide<=0)
    logobardirection=-1;
  
  if(logobardirection==1) {
    $("#logo-bar .go_prev").click();
  } else {
    $("#logo-bar .go_next").click();
  }
}

/* copy SEO table to top */
function SEOtable() {
  fulltext=$(".SEOsection .SectionHeader__Description.Rte").html();
  if(fulltext) {
    textparts=fulltext.split(/\|/); // | to break
    textparts[0]+=" <a href='#seolabel'>MEHR LESEN</a>";
    $("#SEOlinks").remove();
    $(".shopify-section.shopify-section--bordered").first().before("<div id='SEOlinks'>"+textparts[0]+"</div>");   
    $(".SEOsection .SectionHeader__Description.Rte").attr("id","seolabel").attr("name","seolabel").html(textparts[1]);
  }
}
function OLDSEOtable() {
  $(".shopify-section.shopify-section--bordered").first().before("<div id='SEOlinks'></div>");   
  count=0;
  $(".SEOsection").find("h1,h2").each(function(){
    count++;
    $(this).wrap("<a id='seolabel"+count+"' name='seolabel"+count+"'></a>");
    link="<"+$(this).prop("tagName")+"><a href='#seolabel"+count+"'>"+$(this).text()+"</a></"+$(this).prop("tagName")+">";
console.log(link);
    $("#SEOlinks").append(link);
  })  
}

/* Sub category slider */ 
function collectionbar() {

return true; // function disabled!
  
  if($("#collection-bar.image-mosaic").length) {
    return true;
  }
  
  if($('meta[property="og:title"]').attr("content")=="Sale"
  || $('meta[property="og:title"]').attr("content")=="FRAUEN Neu eingetroffen"
  || $('meta[property="og:title"]').attr("content")=="MÄNNER Neu eingetroffen") {
    var filtercat = getUrlParameter('filtercat');
	if(filtercat!="") return true;
  }

  if($("#usf_container").length) {    
// advanced filter system    
    subcats=$(".togglethis[data-section='catlist'] a");
  } else {
// regular filter system  
    subcats=$(".CollectionMain .Catlist a");
  }
  if(subcats.length) {
	$("#collection-bar").remove();
    subcatshtml='';
    subcats.each(function(){
      subcat=$(this).text();
      link=$(this).attr("href");
      image=$(this).data("image");
      if(image!="") {
        subcatshtml=subcatshtml+'<li class="collection-bar__item"><a href="'+link+'">';
        subcatshtml=subcatshtml+'<img src="https://cdn.shopify.com/s/files/1/0626/2688/9955/'+image+'?'+$.now()+'" alt="'+subcat+'">';
        subcatshtml=subcatshtml+'<span>'+subcat+'</span></a></li>';
      }
    })
    if(subcatshtml!="") {
      subcatshtml='<div id="collection-bar"><ul class="collection-bar__list">'+subcatshtml+'</ul></div>';
	  if($("#logo-bar").length)
	  	$("#logo-bar").before(subcatshtml);   
	  else
        $(".shopify-section.shopify-section--bordered").first().before(subcatshtml);   
      //$("nav.breadcrumb").after(subcatshtml);
    }
  }
}

/* Labels page */
function labellist() {
  if(!$("meta[content='Labels']").length) return;
  if($("#main .Rte .labels").length) return;
  
  alllabels=$("#main .Rte").html();
  alllabels=alllabels.replace(/^\n\r|^\n|^\r/g,'').replace(/\n\r$|\n$|\r$/g,'');
  alllabels=alllabels.replace(/\n\r\n\r|\n\n|\r\r/g,'</li></ul><ul><li>');
  alllabels=alllabels.replace(/\n\r|\n|\r/g,'</li><li>');
  newlabels='<div class="labels"><ul><li>'+alllabels+'</li></ul></div>';
  $("#main .Rte").html(newlabels);

  $("#main .Rte .labels ul").each(function(){
	firstletter=$(this).find("li").first().text().trim().substr(0,1).toUpperCase();
    $(this).before('<ul><li><h1>'+firstletter+'</h1></li></ul>');
  });

  $("#main .Rte .labels li").each(function(){
	label=$(this).html();
    if(label.trim()=="" || label.indexOf("</a>")>-1) {
    } else if(label.indexOf("<h1>")>-1) {
//    } else if(label.indexOf("(offline)")>-1) {
      // $(this).html(label.replace(/\(offline\)/g,''));
    } else if(onlinevendors[label.replace(/&amp;/g,'&').trim()] === undefined) {
      // $(this).append(" (offline)"); // Show offline for not in online store
    } else {
      labellink=label.replace(/&amp;/g,'&').trim();
      labellink=encodeURIComponent(label.replace(/&amp;/g,'&').trim());       
      $(this).html('<a href="/collections/vendors?q='+labellink+'">'+label+'</a>');
      onlinevendors[label.replace(/&amp;/g,'&').trim()]="";
    }
  });
  addlabels="";
  for (let label of Object.keys(onlinevendors)) {
    if(onlinevendors[label]!="" && label!="MODE FUNK") {
      labellink=encodeURIComponent(label.replace(/&amp;/g,'&').trim());     
      $(this).html('<a href="/collections/vendors?q='+labellink+'">'+label+'</a>');      
    }
  }
  if(addlabels!="")
    $("#main .Rte .labels").append("<ul><li><h1>Weitere Marken</h1></li></ul><ul>"+addlabels+"</ul>");

  $("#main .Rte .labels").show();
}

/* Functions */
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};
function natsort($array) {
    $array.sort();
    return $array.sort(function (a,b) {
        if ( isNaN(a) && isNaN(b) ) {      
            if (a<=b) { return false; } else { return true; }
        }
        if (isNaN(a)) { return true; }
        if (isNaN(b)) { return false; }      
        return a-b;
    });
}
function mix($array) {
  count=$array.length;
  if(count<2) return;
  parent=$array.eq(0).parent();	
  loop=count*count;
  if(loop>100) loop=100;
  while(loop>0) {
	pos=Math.floor(Math.random()*count);
	$array.eq(pos).detach().appendTo(parent);    
	loop--;
  }
}

(function ($) {
    $.fn.outerHTML = function() {
        return $('<div>').append( this.eq(0).clone() ).html();
        return this;
    };
}(jQuery));

/* move content up for bottom banner */
pause=0;
$('body').bind('DOMSubtreeModified',function(event) {
  if($(".usf-facets.usf-no-select.usf-zone.usf-sr-filters").length && !$(".usf-facets.usf-no-select.usf-zone.usf-sr-filters.caton").length) {
	$(".usf-facets.usf-no-select.usf-zone.usf-sr-filters").addClass("caton");
    $(".usf-facets.usf-no-select.usf-zone.usf-sr-filters div[data-section='catlist']").remove();
    if(advancedmenu!==undefined) $(".usf-sr-filters .usf-body .usf-facets__body").prepend(advancedmenu);   
    synccatlist();
  }  
  if(pause==0){
  pause=1;
  if($("#shopify-privacy-banner-div").length && $("#shopify-privacy-banner-div").is(":visible")) {
    spbd_height=$("#shopify-privacy-banner-div").outerHeight(true);
    $("body").css({marginBottom:spbd_height});
  } else {
    $("body").css({marginBottom:0});
  }
  pause=0;
  }
});